import { Map } from 'immutable';

import { BATCH_ORDER, ORDER_PLAN, CLEAR_ORDER } from './types';


const initialState = Map({
  items: Map(),
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ORDER_PLAN:
      return state.setIn(['items', payload.device_type], payload);
    case BATCH_ORDER:
      return state.withMutations((mutable) => {
        Object
          .keys(payload)
          .forEach((deviceType) => {
            mutable.setIn(['items', deviceType], payload[deviceType]);
          });
      });
    case CLEAR_ORDER:
      return initialState;
    default:
      return state;
  }
};
